import styled, { css } from 'styled-components';
import { SmallShadowIconButton } from 'components/common/material-ui/custom-components';
import { colorUsage, getSpacing } from 'stylesheet';
import { Arrow, EditSquare } from 'theme/icons';
var Container = styled.div.withConfig({
  displayName: "EditBlockToolbarstyle__Container",
  componentId: "sc-bmt2ce-0"
})(["position:sticky;display:flex;flex-direction:column;align-items:center;& >:not(:first-child){margin-top:", ";}"], getSpacing(1));
var SelectButton = styled(EditSquare).withConfig({
  displayName: "EditBlockToolbarstyle__SelectButton",
  componentId: "sc-bmt2ce-1"
})(["width:24px;height:24px;"]);
var MoveBlockButton = styled(SmallShadowIconButton).withConfig({
  displayName: "EditBlockToolbarstyle__MoveBlockButton",
  componentId: "sc-bmt2ce-2"
})(["&:hover path{fill:", ";}"], colorUsage.iconGradientHoverForeground);
var MoveIconStyle = css(["width:14px;height:14px;& path{fill:", ";}"], colorUsage.iconForeground);
var UpIcon = styled(Arrow).withConfig({
  displayName: "EditBlockToolbarstyle__UpIcon",
  componentId: "sc-bmt2ce-3"
})(["", " transform:rotate(90deg);"], MoveIconStyle);
var DownIcon = styled(Arrow).withConfig({
  displayName: "EditBlockToolbarstyle__DownIcon",
  componentId: "sc-bmt2ce-4"
})(["", " transform:rotate(270deg);"], MoveIconStyle);
export { Container, SelectButton, MoveBlockButton, UpIcon, DownIcon };